<template>
  <div class="SAE">
    <div
      style="
        width: 940px;
        margin-bottom: 20px;
        margin-top: 0px;
        position: relative;
      "
      class="lk_content_info_block"
    >
      <div style="display: table-cell; width: 70px">
        <el-icon
          style="
            font-size: 50px;
            position: absolute;
            transform: rotate(180deg);
            left: 20px;
            color: #e82862;
          "
          ><Warning
        /></el-icon>
      </div>
      <div style="display: table-cell">
        <br />
        <span>
          Подписка на выбранный фонд дает возможность получить финансовый
          результат деятельности управляющего фонда. Подписка/отписка по фондам
          без взимания комиссии. Условия фонда зафиксированы в описании.
        </span>

        <br /><br />
      </div>
    </div>
    <template v-for="(item4, i4) in strateges" :key="item4.blockHeader">
      <div class="SAESblockHeader">
        <div>{{ item4.blockHeader }}</div>
      </div>
      <template v-for="(item3, i3) in item4.blockItems" :key="i4 * 100 + i3">
        <el-popover
          placement="top-start"
          :title="item3.name"
          :width="350"
          trigger="hover"
          :content="item3.content"
          popper-class="SAESpopover"
        >
          <template #reference>
            <div class="SAESblock">
              <div class="SAESblockContent">
                <div
                  :style="{
                    background:
                      'url(' + serverUrl + '/' + item3.img + ') no-repeat',
                    'background-repeat-x': 'no-repeat',
                    'background-repeaty': 'no-repeat',
                    'background-position-x': item3.imgx,
                    'background-position-y': item3.imgy,
                  }"
                  class="SAESimg"
                ></div>
                <div class="SAESname">
                  {{ item3.name }} <br />
                  <span class="SAESstartdate"
                    >Старт: 1 {{ item3.priceText }} {{ item3.startDate }}
                  </span>
                  <br />
                  <span
                    @click="SelectLevel('strateges', (i4 + 1) * 100 + i3)"
                    class="viewfull"
                    >Читать полностью</span
                  >
                </div>
                <div class="SAESheader">{{ item3.header }}</div>

                <div class="SAESprice">
                  ЦЕНА:

                  <span v-if="instruments[item3.priceTicker]"
                    ><b>{{ instruments[item3.priceTicker].Last }}</b></span
                  >
                  <span v-else>{{ AddInstrument(item3.priceTicker) }}</span>
                  {{ item3.priceText }}
                </div>
                <div class="SAESprofit" v-if="instruments[item3.priceTicker]">
                  Активы под управлением: {{ (store.aumShares.value[item3.priceTicker]*-1* instruments[item3.priceTicker].Last).toFixed(4)  }} <br>
                  {{
                    GetProfit(
                      item3.startDate,
                      instruments[item3.priceTicker].Last
                    )
                  }}
                </div>
                <div class="SAESMultibuttonBlock">
                  <Button
                    anglecolor="#00a76b"
                    text="Подписаться"
                    class="SAESMultibutton"
                    @click="ConfirmStratege((i4 + 1) * 100 + i3, true)"
                  ></Button>
                  <Button
                    v-if="IsSetPosition(item3.priceTicker)"
                    anglecolor="#00a76b"
                    text="Отписаться"
                    class="SAESMultibutton"
                    @click="ConfirmStratege((i4 + 1) * 100 + i3, false)"
                  ></Button>
                </div>
              </div>
              <div class="SAESGraph">
                <GraphInfo :Ticker="item3.priceTicker"></GraphInfo>
              </div>
            </div>
          </template>
        </el-popover>
      </template>
    </template>
    <ServiceHistoryTable>
      <template v-slot:mtthead="">
        <div class="th">Date</div>
        <div class="th">Fund</div>
        <div class="th"></div>
        <div class="th">Value</div>
        <div class="th">Status</div>
      </template>
      <template v-slot:mttbody="props">
        <div class="tr" v-show="props.item.Service == 'funds'">
          <div class="td">{{ props.item.Date }}</div>
          <div class="td">{{ props.item.HistoryInfo.service }}</div>
          <div class="td">{{ props.item.HistoryInfo.sub }}</div>
          <div class="td">{{ props.item.HistoryInfo.value }}</div>
          <div class="td">{{ props.item.Status }}</div>
        </div>
      </template>
    </ServiceHistoryTable>
  </div>
  <el-dialog v-model="strategesInfoDialog" :title="getStrategeTitle()">
    <FundInfo :ids="selectedStratege" :key="selectedStratege"></FundInfo>
  </el-dialog>
  <el-dialog
    v-model="strategeConfirmDialog"
    :title="getStrategeTitle()"
    width="400px"
  >
    Заявки на подписку/отписку поданные до 9:10 UTC исполняются до 10:10 UTC по
    цене LAST определенной в 9:10 UTC. Операции подписки/отписки производятся в
    понедельник-пятница.
    <br /><br />
    <div style="margin: 6px 0 16px 0">
      <div class="myselector" style="width: 179px">
        <el-select
          v-model="selectedAccount"
          icon-сlass="caret-top"
          placeholder="Select"
        >
          <el-option
            v-for="(item, i) in accountsForSubscribe"
            :key="i"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <el-input-number
      v-model="strategePrice"
      :min="strategeMinPrice"
      :max="strategeMaxPrice"
      :step="strategeStepPrice"
      controls-position="right"
      class="myinputnumber"
    />
    <span v-if="strategeSubscribe"> {{ strategePriceText }}</span>
    <span v-else> Shares</span>
    <template #footer>
      <span class="dialog-footer">
        <el-button class="SAEcancelB" @click="CancelStratege"
          >Отменить</el-button
        >
        <el-button
          class="SAEconfirmB"
          @click="SendStratege"
          :disabled="confirmSubscribe"
          >Отправить</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { defineComponent, reactive, ref, watch } from "vue";
import {
  ElMessageBox,
  ElMessage,
  ElInputNumber,
  ElPopover,
  ElButton,
} from "element-plus";
import { useMyStorage, getInstruments } from "../store/global";
import Button from "./Button";
import FundInfo from "./FundInfo";
import ServiceHistoryTable from "./ServiceHistotyTable";
import axios from "axios";
import GraphInfo from "./Graph";
import { Warning } from "@element-plus/icons-vue";

export default defineComponent({
  name: "ServiceForAE",
  props: { acName: String },
  components: {
    Button,
    FundInfo,
    ElInputNumber,
    ElPopover,
    ElButton,
    ServiceHistoryTable,
    GraphInfo,
    Warning,
  },
  setup(props) {
    const store = useMyStorage();
    const strateges = reactive(store.funds);
    const positions = store.getPositionsFull;
    const instruments = getInstruments();
    const levelInfoDialog = ref(false);
    const selectedLevel = ref(0);
    const indicatorInfoDialog = ref(false);
    const selectedIndicator = ref(0);
    const strategesInfoDialog = ref(false);
    const strategeConfirmDialog = ref(false);
    const strategeMinPrice = ref(0);
    const strategeMaxPrice = ref(0);
    const strategePrice = ref(0);
    const strategeSubscribe = ref(false);
    const selectedStratege = ref(0);
    const sendServiceName = ref("");
    const sendServicePrice = ref(0);
    const strategePriceText = ref("");
    const strategeStepPrice = ref(0);
    const serverUrl = store.ServerUrl;
    const prp = ref(props);
    const selectedStrategeData = ref(strateges[0].blockItems[0]);
    const selectedAccount = ref("");
    const confirmSubscribe = ref(true);
    const accounts = store.userInfo.value.Info.Accounts;
    const accountsForSubscribe = ref([]);
    selectedAccount.value = accounts[0].Account;


    watch(
      () => strategeConfirmDialog.value,
      () => {
        //console.log("change stratege");
        if (strategeConfirmDialog.value === true) {
          selectedAccount.value = "";
          const id = selectedStratege.value % 100;
          const group =
            (selectedStratege.value - (selectedStratege.value % 100)) / 100 - 1;
          selectedStrategeData.value = strateges[group].blockItems[id];
          LoadAccounts();
        }
      }
    );
    watch(
      () => selectedAccount.value,
      () => {
        if (selectedAccount.value != "") {
          setParams();
        }
      }
    );
    const setParams = () => {
      // console.log(selectedStrategeData.value);
      strategeMinPrice.value = 0;
      strategeMaxPrice.value = 0;
      strategePrice.value = 0;
      if (strategeSubscribe.value) {
        // console.log(selectedStrategeData.value);
        strategeMinPrice.value = selectedStrategeData.value.startValue;
        strategeMaxPrice.value = 10000000000000000000;
        strategePrice.value = strategeMinPrice.value;
        let poss = store.getAccPositions(selectedAccount.value).value;
        if (poss != undefined) {
          poss.forEach((pos) => {
            if (
              pos.Ticker === selectedStrategeData.value.volumeText &&
              pos.Shares >= selectedStrategeData.value.startValue
            ) {
              strategeMaxPrice.value = pos.Shares;
              confirmSubscribe.value = false;
            }
          });
        }
      } else {
        let poss = store.getAccPositions(selectedAccount.value).value;
        if (poss != undefined) {
          poss.forEach((pos) => {
            if (pos.Ticker === selectedStrategeData.value.priceTicker) {
              strategeMaxPrice.value = pos.Shares;
              strategePrice.value = pos.Shares;
            }
          });
        }
      }
    };

    const LoadAccounts = () => {
      let sel = false;
      let accList = [];
      accountsForSubscribe.value = accList;
      accounts.forEach((acc) => {
        if (CheckAccountToConfirm(acc.Account)) {
          accList.push(acc.Account);
          if (!sel) {
            selectedAccount.value = acc.Account;
            sel = true;
          }
        }
      });
      if (accList.length < 1) {
        selectedAccount.value = accounts[0].Account;
      }
      accountsForSubscribe.value = accList;
      // console.log(accList);
      setParams();
    };

    const CheckAccountToConfirm = (acc) => {
      // console.log(acc);
      let res = false;
      let poss = store.getAccPositions(acc).value;
      //  console.log(poss);
      if (poss != undefined) {
        // console.log(poss);
        poss.forEach((pos) => {
          //console.log(pos.Ticker);
          //   console.log(selectedStrategeData.value);
          let tickerCheck = "";
          if (strategeSubscribe.value) {
            tickerCheck = selectedStrategeData.value.volumeText;
          } else {
            tickerCheck = selectedStrategeData.value.priceTicker;
          }
          // console.log("---" + tickerCheck);
          if (pos.Ticker === tickerCheck) {
            if (strategeSubscribe.value) {
              //  console.log(selectedStrategeData.value.minShares);
              if (pos.Shares >= selectedStrategeData.value.startValue) {
                res = true;
                return res;
              }
            } else {
              res = true;
              return res;
            }
          }
        });
      }
      return res;
    };

    const AddInstrument = (ticker) => {
      if (instruments[ticker] == undefined) {
        store.subscribeInstrument(ticker);
      }
    };
    const IsSetPosition = (ticker) => {
      var rez = false;
      for (let acc in positions.value) {
        positions.value[acc].forEach((element) => {
          if (element.Ticker === ticker) {
            return (rez = true);
          }
        });
      }
      return rez;
    };
    const SelectLevel = (type, id) => {
      sendServiceName.value = "";
      sendServicePrice.value = 0;
      console.log(id);
      if (type === "level") {
        selectedLevel.value = id;
        levelInfoDialog.value = true;
      }
      if (type === "indicators") {
        selectedIndicator.value = id;
        indicatorInfoDialog.value = true;
      }
      if (type === "strateges") {
        selectedStratege.value = id;
        strategesInfoDialog.value = true;
      }
    };
    function datediff(second, first) {
      return Math.round((second - first) / (1000 * 60 * 60 * 24));
    }
    const GetProfit = (startdate, price) => {
      console.log(startdate);
      console.log(price);
      if (price * 1 != 0) {
        const sdar = startdate.split(".");
        const d1 = new Date(sdar[2], sdar[1] - 1, sdar[0]);
        const d2 = new Date();

        const d3 = datediff(d2.getTime(), d1.getTime());
        //   console.log(d1.getTime()+"___"+d2+"__________"+d3)
        //% годовых = (Цена - 1)*100*365/(Сегодня-Дата старт)

        return (
          "Доходность: " +
          (((price - 1) * 100 * 365) / d3).toFixed(2) +
          "% в год, " +
          ((price - 1) * 100).toFixed(2) +
          "% суммарная"
        );
      }
      return "";
    };
    const CancelStratege = () => {
      strategeConfirmDialog.value = false;
      ElMessage({
        type: "error",
        message: "Заявка отменена",
      });
    };
    const SendStratege = () => {
      if (strategePrice.value == 0) {
        return;
      }
      const id = selectedStratege.value % 100;
      const group =
        (selectedStratege.value - (selectedStratege.value % 100)) / 100 - 1;
      let accounts = store.GetAllAccountsToString();
      let sub = "отписка ";
      if (strategeSubscribe.value) {
        sub = "подписка ";
      }
      let body =
        "Заявка на приобретение услуги: " +
        strateges[group].blockItems[id].priceTicker +
        "\r\n ЛК " +
        store.serverConf[store.currentServer].name +
        "\r\n e@mail: " +
        store.userInfo.value.Roles.email +
        "\r\n  счета клиента: " +
        selectedAccount.value +
        "\r\n услуга: " +
        sub +
        strateges[group].blockItems[id].priceTicker +
        "\r\n объём: " +
        strategePrice.value;
      let data = {
        To: "client@ae.exchange",
        Subject:
          "Заявка на приобретение услуги: " +
          strateges[group].blockItems[id].priceTicker,
        Body: body,
      };
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + store.token.value;
      axios
        .post(store.ServerUrl + "/users/sendtelegram", data)
        .then(function (resp) {
          console.log(resp);
        })
        .catch(function (err) {
          console.log(err);
        });
      console.log(data);
      strategeConfirmDialog.value = false;
      ElMessage({
        type: "success",
        message: "Заявка отправлена",
      });
      let info =
        "{'service':'" +
        strateges[group].blockItems[id].priceTicker +
        "', 'sub':'" +
        sub +
        "', 'value':'" +
        strategePrice.value +
        "', 'login':'" +
        store.userInfo.value.Name +
        "'}";
      let shis = {
        service: "funds",
        accounts: accounts,
        email: store.userInfo.value.Roles.email,
        status: "pending",
        historyinfo: info,
      };
      axios
        .post(store.ServerUrl + "/users/savesevicehistory", shis)
        .finally(() => {
          store.LoadServiceHistory(accounts);
        });
    };
    const ConfirmStratege = (ids, subscribe) => {
      confirmSubscribe.value = true;
      strategeSubscribe.value = subscribe;
      selectedStratege.value = ids;
      strategeMinPrice.value = 0;
      strategeMaxPrice.value = 0;
      strategePrice.value = 0;
      strategeStepPrice.value = 0;
      strategePriceText.value = "";
      const id = selectedStratege.value % 100;
      const group =
        (selectedStratege.value - (selectedStratege.value % 100)) / 100 - 1;
      console.log(strateges[group].blockItems[id].priceTicker);
      if (subscribe) {
        strategeMinPrice.value = strateges[group].blockItems[id].startValue;
        console.log(strategeMinPrice.value);
        //     instruments.value[strateges[id].priceTicker].Last;
        strategePrice.value = strategeMinPrice.value;
        strategeStepPrice.value = strateges[group].blockItems[id].priceStep;
        strategePriceText.value = strateges[group].blockItems[id].volumeText;
        strategePrice.value = strategeMinPrice.value;
        strategeMaxPrice.value = 10000000000000000000;
      } else {
        confirmSubscribe.value = false;
        for (let acc in positions.value) {
          positions.value[acc].forEach((element) => {
            if (
              element.Ticker === strateges[group].blockItems[id].priceTicker
            ) {
              strategePrice.value = element.Shares; // * instruments.value[element.Ticker].Last;
              strategeMaxPrice.value = strategePrice.value;
              strategePriceText.value =
                strateges[group].blockItems[id].volumeText;
            }
          });
        }
      }
      strategeConfirmDialog.value = true;
    };
    const ConfirmOrder = () => {
      const msg = ref("");

      ElMessageBox.confirm(msg.value, "Внимание", {
        confirmButtonText: "Отправить",
        cancelButtonText: "Отменить",
        dangerouslyUseHTMLString: true,
        cancelButtonClass: "SAEcancelB",
        confirmButtonClass: "SAEconfirmB",
        //  type: 'warning',
      })
        .then(() => {
          let accounts = store.GetAllAccountsToString();

          let body =
            "Заявка на приобретение услуги: " +
            sendServiceName.value +
            "\n\r ЛК " +
            store.serverConf[store.currentServer].name +
            "\n\r e@mail: " +
            store.userInfo.value.Roles.email +
            "\n\r  счета клиента: " +
            accounts +
            "\n\r услуга: " +
            sendServiceName.value +
            "\n\r цена: " +
            sendServicePrice.value;
          let data = {
            To: "client@ae.exchange",
            Subject: "Заявка на приобретение услуги: " + sendServiceName.value,
            Body: body,
          };
          axios.defaults.headers.common["Authorization"] =
            "Bearer " + store.token.value;
          axios
            .post(store.ServerUrl + "/users/sendtelegram", data)
            .then(function (resp) {
              console.log(resp);
            })
            .catch(function (err) {
              console.log(err);
            });
          ElMessage({
            type: "success",
            message: "Заявка отправлена",
          });
        })
        .catch(() => {
          ElMessage({
            type: "error",
            message: "Заявка отменена",
          });
        });
    };

    const activeName = ref("first");
    if (prp.value.acName != "") {
      activeName.value = prp.value.acName;
    }
    //    const handleClick = (tab, event) => {
    //   console.log(tab, event);
    //   console.log(activeName.value);
    //  };
    const getStrategeTitle = () => {
      if (selectedStratege.value == 0) {
        return "";
      }
      const id = selectedStratege.value % 100;
      const group =
        (selectedStratege.value - (selectedStratege.value % 100)) / 100 - 1;
      //  console.log(group)
      //  console.log(id)
      return strateges[group].blockItems[id].header;
    };
    return {
      ConfirmOrder,
      SelectLevel,
      selectedLevel,
      strategesInfoDialog,
      selectedStratege,
      serverUrl,
      strateges,
      instruments,
      positions,
      IsSetPosition,
      ConfirmStratege,
      strategeConfirmDialog,
      strategeMinPrice,
      strategeMaxPrice,
      strategePrice,
      SendStratege,
      CancelStratege,
      AddInstrument,
      //    handleClick,
      activeName,
      getStrategeTitle,
      GetProfit,
      strategeStepPrice,
      strategePriceText,
      selectedAccount,
      accounts,
      confirmSubscribe,
      accountsForSubscribe,
      strategeSubscribe,
      store
    };
  },
});
</script>
